import {
    FETCH_SCHEDULE,
    FETCH_SCHEDULE_START,
    FETCH_SCHEDULE_SUCCESS,
    FETCH_SCHEDULE_ERROR,
    UPDATE_SCHEDULE
} from './constants'
import {
    buildAsyncAction
} from 'containers/Async/actions'

const fetchSchedule = (projectId) => ({ type: FETCH_SCHEDULE, projectId })
const fetchScheduleStart = () => ({ type: FETCH_SCHEDULE_START })
const fetchScheduleSuccess = () => ({ type: FETCH_SCHEDULE_SUCCESS })
const fetchScheduleError = () => ({ type: FETCH_SCHEDULE_ERROR})

const updateSchedule = (schedule) => ({ type: UPDATE_SCHEDULE, schedule})

const startFetchScheduleAsync = buildAsyncAction(
    FETCH_SCHEDULE,
    FETCH_SCHEDULE_START,
    [FETCH_SCHEDULE_ERROR, FETCH_SCHEDULE_SUCCESS]
)

export {
    startFetchScheduleAsync,
    fetchSchedule,
    fetchScheduleStart,
    fetchScheduleSuccess,
    fetchScheduleError,
    updateSchedule
}